import SunAccent from "@/components/feature/SunAccent";
import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import { brand } from "@/mocks/siteData";

export default function FinalCtaSection() {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20winding%20earthen%20road%20leading%20through%20vibrant%20green%20paddy%20fields%20towards%20a%20traditional%20Indian%20village%20at%20fresh%20dusk%2C%20distant%20coconut%20palms%20and%20a%20soft%20fresh%20sky%2C%20hopeful%20cinematic%20painterly%20stylized%20earthy%20tones%2C%20flooded%20with%20golden%20sunrise%20light%2C%20warm%20amber%20sunrays%20and%20soft%20glow%2C%20misty%20atmospheric%20haze%2C%20deep%20rich%20shadows%2C%20vivid%20saturated%20lush%20green%2C%20high%20contrast%20cinematic%20golden%20hour%20richness%2C%20ultra%20detailed&nocache=true&width=1920&height=1000&seq=rythugaru-final-cta-road&orientation=landscape"
          width={1920}
          height={1000}
          alt="A winding road leading through green fields toward a village at sunset"
          title="Come back to your roots with Rythugaru"
          className="w-full h-full object-cover object-top"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/55 to-black/75"></div>
        <div className="pointer-events-none absolute inset-0 sun-glaze"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 py-24 md:py-32 text-center">
        <Reveal>
          <div className="mb-4">
            <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" />
          </div>
          <span className="text-xs font-semibold tracking-[0.28em] uppercase text-accent-300">
            {brand.fullName}
          </span>
          <h2 className="font-heading text-4xl md:text-6xl text-background-50 font-semibold mt-5 max-w-3xl mx-auto leading-tight">
            Come Back to Your Roots
          </h2>
          <div className="mt-8 max-w-2xl mx-auto space-y-3">
            <p className="text-base md:text-lg text-background-200">The city gives us convenience.</p>
            <p className="text-base md:text-lg text-background-100 font-medium">
              The farm gives us connection.
            </p>
            <p className="text-base md:text-lg text-background-200 mt-4">
              Come meet the people who grow our food. Come walk through the fields. Come taste food
              at its source. Come listen to stories from the soil.
            </p>
          </div>

          <p className="font-heading text-2xl md:text-4xl text-accent-300 mt-9 max-w-2xl mx-auto italic">
            Come experience the life behind your food.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-10">
            <a
              href="#experiences"
              className="inline-flex items-center justify-center gap-2 bg-accent-500 text-background-50 text-sm md:text-base font-semibold px-8 py-4 rounded-md hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Explore Experiences
              <i className="ri-arrow-right-line"></i>
            </a>
            <Link
              to="/farm-partner"
              className="inline-flex items-center justify-center gap-2 bg-background-50/10 backdrop-blur-sm border border-background-50/40 text-background-50 text-sm md:text-base font-semibold px-8 py-4 rounded-md hover:bg-background-50/20 transition-colors whitespace-nowrap cursor-pointer"
            >
              Become a Farm Partner
              <i className="ri-plant-line"></i>
            </Link>
          </div>

          <p className="font-heading italic text-accent-300 text-lg mt-10">{brand.tagline}</p>
        </Reveal>
      </div>
    </section>
  );
}